import moment from "moment";
import React from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import pluralize from "pluralize";

const TotalsColumn = ({
  date,
  events,
  showJobCounts,
  showUOMTotals,
  includedItemTypes,
  showEstimatedQuantities,
  currentDate,
  styles,
}) => {
  const dayEvents = events
    .flatMap(({ events }) =>
      events
        .filter((e) => !date.isBefore(e.startDate) && !date.isAfter(e.endDate))
        .filter((e) => e.job)
    )
    .reduce((uniqueJobs, event) => {
      if (
        !uniqueJobs.some(
          (existingEvent) => existingEvent.job.id === event.job.id
        )
      ) {
        uniqueJobs.push(event);
      }
      return uniqueJobs;
    }, []);

  const jobCount = dayEvents.length;

  // Calculate material totals by item type
  const materialTotals = dayEvents.reduce((totals, event) => {
    if (event.job && event.job.items) {
      event.job.items.forEach((jobItem) => {
        if (!jobItem.item || !jobItem.item.itemType) return;
        const key = jobItem.item.itemType.id;
        const quantity = showEstimatedQuantities
          ? jobItem.estimatedQuantity
          : jobItem.proposedQuantity;
        const label = showEstimatedQuantities
          ? jobItem.item.itemType.estimatedQuantityLabel
          : jobItem.item.itemType.quantityLabel;
        if (!totals[key]) {
          totals[key] = { value: 0, uom: jobItem.item.uom || "", label: label };
        }
        totals[key].value += quantity || 0;
      });
    }
    return totals;
  }, {});

  const lineItemStyle = {
    borderBottom: "1px solid var(--Neutrals-300, #E0E1E2)",
    padding: "4px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const totalsContainerStyle = {
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "12px",
    margin: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    minHeight: "60px",
  };

  return (
    <div className={[styles.column, styles.totals].join(" ")}>
      <div
        className={[
          styles.totalsContainer,
          moment(currentDate).startOf("day").isSame(date) ? styles.active : "",
        ].join(" ")}
        style={totalsContainerStyle}
      >
        {showJobCounts && (
          <div
            style={{
              padding: "4px 0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              alignSelf: "stretch",
            }}
          >
            <span
              style={{
                color: "var(--JobPro-Complementary-900, #466347)",
                textAlign: "center",
                fontFamily: "Fira Sans",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "normal",
                textTransform: "uppercase",
              }}
            >
              DAILY TOTALS
            </span>
            <b>Jobs: {jobCount}</b>
          </div>
        )}
        {showUOMTotals && (
          <FormGroup
            className={styles.dataValuePair}
            style={{ marginBottom: 0 }}
          >
            <ControlLabel className={styles.dataValuePairLabel}>
              Materials
            </ControlLabel>
            <FormControl.Static
              componentClass={"div"}
              className={styles.dataValuePairValue}
            >
              <div>
                {Object.entries(materialTotals).filter(
                  ([itemTypeId]) =>
                    includedItemTypes &&
                    typeof includedItemTypes === "object" &&
                    includedItemTypes[itemTypeId]
                ).length > 0 ? (
                  Object.entries(materialTotals)
                    .filter(
                      ([itemTypeId]) =>
                        includedItemTypes &&
                        typeof includedItemTypes === "object" &&
                        includedItemTypes[itemTypeId]
                    )
                    .map(([itemTypeId, { value, label }]) => {
                      const itemType = includedItemTypes[itemTypeId];
                      const displayLabel = showEstimatedQuantities
                        ? label
                        : itemType.inventoryQuantityLabel &&
                          itemType.inventoryQuantityLabel !==
                            itemType.quantityLabel
                        ? pluralize(itemType.inventoryQuantityLabel)
                        : itemType.quantityLabel;
                      return (
                        <div key={itemTypeId} style={lineItemStyle}>
                          <span>{itemType.name}:</span>
                          <span>
                            {Math.round(value * 1000) / 1000} {displayLabel}
                            {!showEstimatedQuantities &&
                            itemType.installedQuantityLabel &&
                            itemType.installedQuantityLabel !==
                              itemType.inventoryQuantityLabel
                              ? ` (${itemType.installedQuantityLabel})`
                              : ""}
                          </span>
                        </div>
                      );
                    })
                ) : (
                  <div style={lineItemStyle}>
                    <span>None</span>
                  </div>
                )}
              </div>
            </FormControl.Static>
          </FormGroup>
        )}
      </div>
    </div>
  );
};

export default TotalsColumn;
